export interface BrandChannel {
  connectedId: string;
  id: string;
  name: string;
}
/**
 * 브랜드 제휴사 리스트
 * 해당 점주가 해당 브랜드 주문 시스템과 연동한 경우에만 노출.
 */

const brandChannelList: BrandChannel[] = [
  { connectedId: "bmSmileYn", id: "bmSmile", name: "위글루션" },
  { connectedId: "gamsungCoffeeYn", id: "gamsungCoffee", name: "감성커피" },
  { connectedId: "routinecoffeeYn", id: "routinecoffee", name: "루틴커피" },
  { connectedId: "theliterYn", id: "theliter", name: "더리터" },
  { connectedId: "talkpickYn", id: "talkpick", name: "톡포장" },
  { connectedId: "demonstrationYn", id: "demonstration", name: "VD시연용" },
  { connectedId: "baegeokcoffeeYn", id: "baegeokcoffee", name: "백억커피" },
  { connectedId: "baroderYn", id: "baroder", name: "바로더" },
  { connectedId: "hasamdongcoffeeYn", id: "hasamdongcoffee", name: "하삼동커피" },
];

export default brandChannelList;
